import moment from "moment-timezone";

/**
 * This function takes a surcharge type and returns a human-readable string.
 * @param {string} type - The type of surcharge.
 * @returns {string} A human-readable string representing the surcharge type.
 */
export function formatSurchargeType(type) {
    if (type === "blackouts") {
        return "Blackouts Dates";
    } else if (type === "special_event") {
        return "Special Event";
    } else if (type === "weekend_dates") {
        return "Weekend Fees";
    } else if (type === "night_fees") {
        return "Night Fees";
    } else if (type === "seasonal") {
        return "Seasonal Fees";
    } else if (type === "availability_on_request") {
        return "Availability on Request";
    }
    return "Unknown";
}

/**
 * This function takes a surcharge extra type and returns a human-readable string.
 * @param {string} type - The type of surcharge extra.
 * @returns {string} A human-readable string representing the surcharge extra type.
 */
export function getSurchargeSymbol(type) {
    if (type === "percentage") {
        return "%";
    } else {
        return "$";
    }
}

/**
 * This function takes a surcharge markup type and returns a human-readable string.
 * @param {string} type - The type of surcharge markup.
 * @returns {string} A human-readable string representing the surcharge markup type.
 */
export function formatSurchargeDate(date) {
    return moment(date)
        .utc(true)
        .format("DD-MMM-YYYY");
}

/** Surcharge types whose rule uses a time range (start and end time). */
const TIME_RANGE_SURCHARGE_TYPES = ["special_event", "night_fees"];

/**
 * Checks whether a surcharge type uses a time range, so its start and end times are shown.
 * @param {string} type - The surcharge type.
 * @returns {boolean} True for a special event or a night fee.
 */
export function hasSurchargeTimeRange(type) {
    return TIME_RANGE_SURCHARGE_TYPES.includes(type);
}

/**
 * This function takes a category type and returns a human-readable string.
 * @param {string} category - The category type.
 * @returns {string} A human-readable string representing the category type.
 */
export function formatCategoryType(category) {
    if (category === "business") {
        return "Business";
    } else if (category === "luxury") {
        return "Luxury";
    } else {
        return "Standard";
    }
}

/**
 * This function takes a vehicle type and returns a human-readable string.
 * @param {string} type - The type of vehicle.
 * @returns {string} A human-readable string representing the vehicle type.
 */
export function formatVehicleType(type) {
    if (type === "sedan") {
        return "Sedan";
    } else if (type === "boat") {
        return "Boat";
    } else if (type === "coach") {
        return "Coach";
    } else if (type === "limousine") {
        return "Limousine";
    } else if (type === "minibus") {
        return "Minibus";
    } else if (type === "midicoach") {
        return "Midicoach";
    } else if (type === "minivan") {
        return "Minivan";
    } else if (type === "mpv") {
        return "Mpv";
    } else if (type === "pickup") {
        return "Pickup";
    } else if (type === "premium_sedans") {
        return "Premium Sedans";
    } else if (type === "suvs") {
        return "SUVs";
    }
}

/**
 * This function takes a rate type and returns a human-readable string.
 * @param {string} type - The type of rate.
 * @returns {string} A human-readable string representing the rate type.
 */
export function formatRateType(type) {
    if (type === "travel") {
        return "By Distance";
    } else {
        return "Area + Distance";
    }
}

/**
 * This function takes a rate status and returns a human-readable string.
 * @param {string} status - The status of the rate.
 * @returns {string} A human-readable string representing the rate status.
 */
export function formatRateStatus(status) {
    if (status === "ACTIVE") {
        return "Active";
    } else if (status === "INACTIVE") {
        return "Inactive";
    } else if (status === "EXPIRED") {
        return "Expired";
    }

    return "Unknown";
}